import { withStyles } from "@mui/styles";
import Tab, { TabProps } from "@mui/material/Tab";

const CustomTab = withStyles({
  root: {
    textTransform: "none",
    fontSize: 18,
  },
  selected: {
    color: "#457dd9 !important",
  },
})((props: TabProps) => <Tab {...props} />);

export default CustomTab;
